export const DASHBOARD = "/"

/**
 * ASSETS
 */
export const PLANTILLA_ACTIVOS =
  "/erp/plantillas/Plantilla_Importar_Activos.xlsx"
export const PLANTILLA_FACTURAS =
  "/erp/plantillas/Plantilla_Importar_Facturas.xlsx"

/**
 * USER
 */
export const LOGIN = "/login"
export const LOGIN_BACKUP = "/login-backup"
export const LOGIN_INTERNO = "/login-interno"
export const LOGIN_INTERNO_BACKUP = "/login-interno-backup"
export const SIGN_UP = "/signup-backup"
export const RECOVERY_PASSWORD_STEP_1 = "/recovery-password-step-1-backup"
export const RECOVERY_PASSWORD_STEP_2 = "/recovery-password-step-2-backup"

/**
 * DOCUMENTOS
 */
export const ALBARANES = "/documentos/albaranes"
export const CREAR_ALBARAN = "/crear-albaran"
export const CREAR_FACTURA = "/crear-factura"
export const CREAR_FACTURA_PROFORMA = "/crear-factura-proforma"
export const CREAR_FACTURA_RECURRENTE = "/crear-factura-recurrente"
export const CREAR_PEDIDO = "/crear-pedido"
export const CREAR_PRESUPUESTO = "/crear-presupuesto"
export const CREAR_TICKET = "/documentos/tickets/crear"
export const DOCUMENTOS = "/documentos"
export const EDITAR_FACTURA_RECURRENTE = "/editar-factura-recurrente"
export const EDITAR_FACTURA_RECURRENTE_ID = "/editar-factura-recurrente/:id"
export const EDITAR_TICKET = "/documentos/tickets/:id"
export const FACTURAS = "/documentos/facturas"
export const FACTURAS_PROFORMA = "/documentos/facturas-proforma"
export const FACTURAS_FINANCIABLES = "/documentos/facturas-financiables"
export const FACTURAS_RECURRENTES = "/documentos/facturas-recurrentes"
export const FACTURAS_RECURRENTES_DETAIL =
  "/documentos/facturas-recurrentes/:id"
export const PEDIDOS = "/documentos/pedidos"
export const PRESUPUESTOS = "/documentos/presupuestos"
export const TICKETS = "/documentos/tickets"

/**
 * EMPRESA
 */
export const EMPRESAS = "/empresas"
export const CONTACTOS = "/contactos"
export const EDITAR_CONTACTO = "/contactos/:id"
export const PROFILE = "/perfil/mis_datos"
export const MIS_EMPRESAS = "/perfil/mis-empresas"
export const EMPRESA = "/perfil/empresa"
export const EMPRESAS_GESTIONADAS = "/perfil/empresas-gestionadas"
export const CUENTAS = "/perfil/cuentas"
export const BANK_ACCOUNT_MANAGER = "/mis-cuentas-bancarias"
export const ADMROLES = "/perfil/usuarios"
export const APPROVALS = "/perfil/aprobaciones"
export const TAXES = "/perfil/impuestos"
export const CUENTAS_CONTABLES = "/perfil/cuentas-contables"
export const COMPANY_CATEGORIES = "/perfil/categorias"
export const INTEGRATION_UPDATE = "/integraciones/importar"
export const INTEGRACIONES = "/integraciones"

/**
 * INVENTARIO
 */
export const INVENTARIO = "/inventario"
export const ARTICULOS = "/inventario/articulos"
export const CATALOGOS = "/inventario/catalogos"
export const CATEGORIAS = "/inventario/categorias"
export const CREAR_CATALOGO = "/inventario/nuevo-catalogo"
export const VIEW_SHARED_CATALOGO = "/catalogo/:id/compartido"
export const VIEW_CATALOGO = (id = ":id") => `/inventario/catalogo/${id}`
export const EDIT_CATALOGO = (id = ":id") => `/inventario/catalogo/${id}/editar`

/**
 * IMPORTAR
 */
export const REVISION_FACTURA_OCR = (id = ":id") => `/ocr/validar/${id}`
export const IMPORTAR = "/importar"
export const IMPORTAR_FACTURAS = "#/importar/facturas"
export const IMPORTAR_CONTACTOS = "/importar/contactos"
export const IMPORTAR_ACTIVOS = "/importar/activo"
export const IMPORTAR_PRODUCTOS = "/importar/productos"
export const IMPORTAR_FACTURAS_OCR = "/ocr"
export const IMPORTAR_FACTURAE = "#/importar/facturae"

/**
 * TESORERIA
 */
export const TESORERIA = "/tesoreria"
export const BANCOS = "/tesoreria/bancos"
export const CARTERA = "/tesoreria/cartera"
export const TARJETAS = "/tesoreria/tarjeta"
export const DEVOLUCIONES_INGRESOS = "/tesoreria/devoluciones-ingresos"
export const PAGOS_COBROS = "/tesoreria/pagos-cobros"
export const REMESAS = "/tesoreria/remesas"
export const BANCOS_DETAIL = "/tesoreria/bancos/:id"
export const TARJETA_DETAIL = "/tesoreria/tarjeta/:id"
export const REEMBOLSO_TICKETS = "/tesoreria/reembolso-tickets"
export const REMESAS_DETAIL = "/tesoreria/remesas/:id"
export const CONCILIACION = (id = ":id") =>
  `/tesoreria/bancos/${id}/conciliacion`
export const REGLAS_CONCILIACION = "/tesoreria/reglas-conciliacion"
export const REGLAS_CONCILIACION_DETAIL =
  "/tesoreria/reglas-conciliacion/:nifTitular"
export const REGLAS_CONCILIACION_REGLA =
  "/tesoreria/reglas-conciliacion/regla/crear"
export const REGLAS_CONCILIACION_REGLA_DETAIL =
  "/tesoreria/reglas-conciliacion/regla/:reglaId"
export const PROPUESTAS_CONCILIACION = "/tesoreria/propuestas-conciliacion"
export const PROPUESTAS_CONCILIACION_DETAIL =
  "/tesoreria/propuestas-conciliacion/:cuentaId"

/**
 * CONTABILIDAD
 */

export const CONTABILIDAD_CUENTAS = () => {
  localStorage.removeItem("cuentacontable")
  return "/contabilidad/cuentas-contables"
}

export const CONTABILIDAD = `/contabilidad`
export const CONTABILIDAD_CUENTAS_CONTABLES = `/contabilidad/cuentas-contables/`
export const CONTABILIDAD_LIBRO = `/contabilidad/libro-diario/`
export const CONTABILIDAD_BALANCE = `/contabilidad/balance`
export const CONTABILIDAD_PERDIDAS_GANANCIAS = `/contabilidad/perdidas-ganancias`
export const CONTABILIDAD_SUMAS_SALDOS = `/contabilidad/sumas-saldos`
export const LIBRO_MAYOR = `/contabilidad/libro-mayor`
export const LIBRO_MAYOR_DETAIL = `/contabilidad/libro-mayor/:id`
export const PRESTAMOS = "/contabilidad/prestamos"
export const PRESTAMOS_DETAIL = "/contabilidad/prestamos/:id"
export const RESUMEN_IMPUESTOS = "/contabilidad/detalle-impuestos"
export const DECLARACION_MODELO_180 = "/contabilidad/declaracion/modelo-180"
export const DECLARACION_MODELO_190 = "/contabilidad/declaracion/modelo-190"
export const DECLARACION_MODELO_303 = "/contabilidad/declaracion/modelo-303"
export const DECLARACION_MODELO_347 = "/contabilidad/declaracion/modelo-347"
export const DECLARACION_MODELO_349 = "/contabilidad/declaracion/modelo-349"
export const DECLARACION_MODELO_390 = "/contabilidad/declaracion/modelo-390"

export const RESUMEN_IMPUESTOS_DETAIL =
  "/contabilidad/detalle-impuestos/:modeloId"
export const RESUMEN_IMPUESTOS_DETAIL_180 =
  "/contabilidad/detalle-impuestos/180"
export const RESUMEN_IMPUESTOS_DETAIL_190 =
  "/contabilidad/detalle-impuestos/190"
export const RESUMEN_IMPUESTOS_DETAIL_347 =
  "/contabilidad/detalle-impuestos/347"
export const ACTIVOS = "/contabilidad/activos"
export const ACTIVO_ID = "/contabilidad/activos/:activoId"

/**
 * NOTIFICACIONES
 */

export const NOTIFICATIONS = `/notificaciones`

/**
 *
 * APLICACIONES
 */

export const ERP = "/erp"

// VALIDACIONES
export const VALIDACIONES_CESIONES = "/validaciones-cesiones"
export const VALIDACIONES_FINANCIACION = "/validaciones-financiacion"
export const VALIDACIONES_DOCUMENTOS = "/validaciones-documentos"

export const VALIDACIONES_DOCUMENTOS_DETAIL = (id = ":id") =>
  `/validaciones-documentos/${id}`

export const VALIDACIONES_FINANCIACION_DETAIL = (id = ":id") =>
  `/validaciones-financiacion/${id}`
